import http from 'conversations-http/clients/http';
const CV_FORMS_INTEGRATION_LEGACY_PREFIX = 'cv-forms-integration-legacy/v1';
export const getConnectedForms = async () => await http.get(`${CV_FORMS_INTEGRATION_LEGACY_PREFIX}/connected-crm-object`);